import { createSelector } from 'reselect'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import viewsWithoutIcons from 'helpers/viewsWithoutIcons'

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.MAIN_TOPBAR_TOOLTIPS,
	featureFlagsTypes.QUICK_LAUNCH_FIELDTRIP,
	featureFlagsTypes.QUICK_LAUNCH_DRAWIT,
	featureFlagsTypes.QUICK_LAUNCH_OEQ,
	featureFlagsTypes.QUICK_LAUNCH_TIMER,
	featureFlagsTypes.QUICK_LAUNCH_COLLABORATE,
])

const getCurrentView = state => state.ui.currentView
const userExtraSelector = state => state.user.extra ? state.user.extra : {}

const getQuickLaunchData = createSelector(
	[featureFlagsSelector, getCurrentView, userExtraSelector],
	(featureFlags, currentView, userExtra) => {
		const canShowItems = !viewsWithoutIcons.includes(currentView)

		const tooltips = userExtra.tooltips ? userExtra.tooltips : {}
		const shouldShowQuickLaunch = (featureFlags[featureFlagsTypes.QUICK_LAUNCH_FIELDTRIP]
		|| featureFlags[featureFlagsTypes.QUICK_LAUNCH_DRAWIT]
		|| featureFlags[featureFlagsTypes.QUICK_LAUNCH_OEQ]
		|| featureFlags[featureFlagsTypes.QUICK_LAUNCH_TIMER]
		|| featureFlags[featureFlagsTypes.QUICK_LAUNCH_COLLABORATE])
		&& canShowItems

		return {
			shouldShowQuickLaunch,
			shouldShowQuickLaunchDrawIt: featureFlags[featureFlagsTypes.QUICK_LAUNCH_DRAWIT],
			shouldShowQuickLaunchFieldTrip: featureFlags[featureFlagsTypes.QUICK_LAUNCH_FIELDTRIP],
			shouldShowQuickLaunchOeq: featureFlags[featureFlagsTypes.QUICK_LAUNCH_OEQ],
			shouldShowQuickLaunchTimer: featureFlags[featureFlagsTypes.QUICK_LAUNCH_TIMER],
			shouldShowQuickLaunchCollaborate: featureFlags[
				featureFlagsTypes.QUICK_LAUNCH_COLLABORATE
			],
			shouldShowQuickLaunchTooltip: shouldShowQuickLaunch && !!tooltips.tooltipQuickLaunch,
		}
	}
)

export default getQuickLaunchData
